import { Link } from "react-router-dom";
import { dailyCollections } from "@/mocks/daily";

export default function CollectionList() {
  return (
    <div className="rounded-card border border-background-200/80 bg-background-50 p-5">
      <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-calendar-check-line text-primary-500"></i>
        </span>
        最近七日合集
      </h2>
      <ul className="mt-4 flex flex-col gap-1">
        {dailyCollections.map((item) => (
          <li key={item.slug}>
            <Link
              to={`/article/${item.articleSlugs[0]}`}
              className="group flex items-start gap-3 rounded-lg px-2 py-2.5 transition-colors duration-200 hover:bg-primary-50/70"
            >
              <span className="flex shrink-0 flex-col items-center rounded-lg bg-background-200/80 px-2 py-1">
                <span className="font-heading text-xs font-bold text-foreground-800">
                  {item.date.slice(5).replace("-", "/")}
                </span>
                <span className="text-[10px] text-foreground-500">{item.weekday}</span>
              </span>
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors duration-200 group-hover:text-primary-700">
                  {item.title.replace(/^每日合集·[^｜]*｜/, "")}
                </span>
                <span className="mt-1 text-xs text-foreground-500">
                  收录 {item.articleSlugs.length} 条话题
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}